module.exports = __webpack_public_path__ + "images/exterior-3d-1-76ccb9c1a0a87a2bc5f6f885547a4833.jpg";